import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { getDecryptDataFromLocal } from "../../utils/encrypt";

function AlertModal({ visible, onClose, orderId }) {
  const [disableBtn, setDisableBtn] = useState(false);
  const [awbNumber, setAwbNumber] = useState("");
  const [boxCount, setBoxCount] = useState("");
  const [selectedCourier, setSelectedCourier] = useState(null);
  const accessButton = ["9719836187", "8826193896", "8800970879",'9891774071','7052950504','9599412543','9034223172',"8130902064","WAREHOUSE21","WAREHOUSE47","9910249015"];
  const selfPickupUsers = ["9315481432", "7838688729", "9536255229"];
  const phoneNumber = getDecryptDataFromLocal("phoneNumber");

  // Reset AWB input state when modal closes
  useEffect(() => {
    if (!visible) {
      setSelectedCourier(null);
      setAwbNumber("");
      setBoxCount("");
      setDisableBtn(false);
    }
  }, [visible]);

  useEffect(() => {
    if ((selectedCourier === "SHIPSHOPY" || selectedCourier === "ROCKETBOX") && orderId) {
      axios
        .get(
          `${process.env.REACT_APP_PATH_BULK}/products/getShipmentBoxForOrder?orderId=${orderId}`
        )
        .then((res) => {
          if (res.data.success) {
            setBoxCount(res.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [selectedCourier, orderId]);
  const shipOnPorter = (e) => {
    if (!boxCount) {
      if (
        !window.confirm(
          "Are you sure you want to continue without box count?"
        )
      ) {
        return;
      }
    }
    setDisableBtn(true);
    let url = `${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromRocketBox`;
    const dataObj = {
      orderId: orderId,
      isrocketOrPorter: false,
      ...(boxCount && { boxCount: boxCount }),
    };
    // console.log('mooimlk',dataObj)
    axios({
      method: "POST",
      url: url,
      data: dataObj,
    })
      .then((res) => {
        if (res.data.success) {
          setDisableBtn(false);
          res?.data?.data?.labelUrl &&
            window.open(res?.data?.data?.labelUrl, "_blank");

          alert("orders shipped successful");
          window.location.reload();
        } else {
          alert(res.data.message);
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        let error = err?.response?.data?.message || "";

        if (error == "") {
          for (let key in err?.response?.data?.message) {
            if (err?.response?.data?.message?.hasOwnProperty(key)) {
              error = err?.response?.data?.message[key];
              break;
            }
          }

          alert(error);
        }
        setDisableBtn(false);
      });
  };

  const shipOnShipShopy = (e) => {
    // if (!awbNumber.trim()) {
    //   alert("Please enter AWB Number");
    //   return;
    // }

    if (!boxCount) {
      if (
        !window.confirm(
          "Are you sure you want to continue without box count?"
        )
      ) {
        return;
      }
    }
    setDisableBtn(true);
    let url = `${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromRocketBox`;
    const dataObj = {
      orderId: orderId,
      isrocketOrPorter: false,
      orderType: "shipShopy",
      // awbNumber: awbNumber.trim(),
      ...(boxCount && { boxCount: boxCount }),
    };
    axios({
      method: "POST",
      url: url,
      data: dataObj,
    })
      .then((res) => {
        if (res.data.success) {
          setDisableBtn(false);
          res?.data?.data?.labelUrl &&
            window.open(res?.data?.data?.labelUrl, "_blank");

          alert("orders shipped successful");
          window.location.reload();
        } else {
          alert(res.data.message);
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        let error = err?.response?.data?.message || "";

        if (error == "") {
          for (let key in err?.response?.data?.message) {
            if (err?.response?.data?.message?.hasOwnProperty(key)) {
              error = err?.response?.data?.message[key];
              break;
            }
          }

          alert(error);
        }
        setDisableBtn(false);
      });
  };

  const handleSelfPickup = () => {
    if (!window.confirm("Are you sure you want to mark this order as Self Pickup (Delivered)?")) return;
    setDisableBtn(true);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_PATH_BULK}/products/markBulkOrderSelfPickup`,
      data: { orderId },
    })
      .then((res) => {
        if (res.data.success) {
          alert("Order marked as self pickup and delivered successfully");
          window.location.reload();
        } else {
          alert(res.data.message || "Something went wrong");
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        alert(err?.response?.data?.message || "Something went wrong");
        setDisableBtn(false);
      });
  };

  const SubmitOnRocketBox = (e) => {
    // packaging (weight + carton size) is built on the server from this box count
    if (!boxCount || Number(boxCount) < 1) {
      alert("Please enter box count");
      return;
    }
    setDisableBtn(true);
    // let url = bulkOrder?`${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromUc` : openShipmentPopup?.type == 'unicommerce' ? `${process.env.REACT_APP_PATH_BULK}/products/shipOrderFromUc` : `${process.env.REACT_APP_PATH_BULK}/products/shipFloridaOrder`
    let url = null;
    url = `${process.env.REACT_APP_PATH_BULK}/products/shipBulkOrderFromRocketBox`;

    const dataObj = {
      orderId: orderId,
      isrocketOrPorter: true,
      packagingUnitDetails:[],
      ...(boxCount && { boxCount: boxCount }),
    };
    axios({
      method: "POST",
      url: url,
      data: dataObj,
    })
      .then((res) => {
        if (res.data.success) {
          setDisableBtn(false);
          res?.data?.data?.labelUrl &&
            window.open(res?.data?.data?.labelUrl, "_blank");
          alert("orders shipped successful");
          window.location.reload();
        } else {
          let error = res.data.message || "";
          alert(error);
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        let error = err?.response?.data?.message || "";
        if (openShipmentPopup?.type == "unicommerce") {
          alert(error);
          window.location.reload();
        } else {
          if (error == "") {
            for (let key in err?.response?.data?.message) {
              if (err?.response?.data?.message?.hasOwnProperty(key)) {
                error = err?.response?.data?.message[key];
                break;
              }
            }
          }
          alert(error);
        }
        setDisableBtn(false);
      });
  };

  return (
    <Dialog
      open={visible}
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title">
          <Grid container>
            <Grid item lg={10}>
              <Typography variant="h2">Select delivery partner</Typography>
            </Grid>
            <Grid item lg={2} justifyContent={"flex-end"} display={"flex"}>
              <Button variant="outlined" onClick={onClose}>
                Close
              </Button>
            </Grid>
          </Grid>
        </DialogTitle>
        <Grid container>
          <Grid item lg={12}>
            <Divider />
          </Grid>
        </Grid>
        {selfPickupUsers.includes(phoneNumber) && (
          <Grid container mt={2} spacing={2}>
            <Grid item lg={12} md={12} sm={12}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSelfPickup}
                disabled={disableBtn}
                fullWidth
              >
                Self Pickup
              </Button>
            </Grid>
          </Grid>
        )}

        {accessButton.includes(phoneNumber) && (
          <>
            {!selectedCourier && (
              <Grid container mt={2} spacing={2}>
                <Grid item lg={4} md={4} sm={12}>
                  <Grid>
                    <Button
                      variant="contained"
                      onClick={() => setSelectedCourier("PORTER")}
                      disabled={disableBtn}
                      fullWidth
                    >
                      Porter
                    </Button>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4} sm={12}>
                  <Grid>
                    <Button
                      variant="contained"
                      onClick={() => setSelectedCourier("SHIPSHOPY")}
                      disabled={disableBtn}
                      fullWidth
                    >
                      ShipShopy
                    </Button>
                  </Grid>
                </Grid>
                <Grid item lg={4} md={4} sm={12}>
                  <Grid>
                    <Button
                      disabled={disableBtn}
                      color="primary"
                      variant="contained"
                      onClick={() => setSelectedCourier("ROCKETBOX")}
                      fullWidth
                    >
                      Rocket Box
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            )}

            {selectedCourier && (
              <Grid container mt={2} spacing={2}>

                <Grid item lg={12} md={12} sm={12}>
                  <TextField
                    label={boxCount ? "Box Count" : "Box Count (Suggestion)"}
                    variant="outlined"
                    fullWidth
                    value={boxCount}
                    onChange={(e) => setBoxCount(e.target.value)}
                    type="number"
                    helperText={
                      selectedCourier === "SHIPSHOPY" || selectedCourier === "ROCKETBOX"
                        ? "Suggested box count"
                        : ""
                    }
                  />
                </Grid>
                {/* {selectedCourier === "SHIPSHOPY" && (
                  <Grid item lg={12} md={12} sm={12}>
                    <TextField
                      label="AWB Number"
                      variant="outlined"
                      fullWidth
                      value={awbNumber}
                      onChange={(e) => setAwbNumber(e.target.value)}
                      disabled={disableBtn}
                      required
                    />
                  </Grid>
                )} */}
                <Grid item lg={12} md={12} sm={12}>
                  <Grid container spacing={2}>
                    <Grid item>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={
                          selectedCourier === "PORTER"
                            ? shipOnPorter
                            : selectedCourier === "SHIPSHOPY"
                            ? shipOnShipShopy
                            : SubmitOnRocketBox
                        }
                        disabled={
                          disableBtn
                        }
                      >
                        Ship By {selectedCourier}
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setSelectedCourier(null);
                          setAwbNumber("");
                          setBoxCount("");
                        }}
                        disabled={disableBtn}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default AlertModal;
